import { getUrlAPIv2 } from '../api';
import { FormasPagamento } from '../model/fomaPagamentoEmpresa.model';

const getFormaPagamentoEmpresa = async (empresaID: number, token: string): Promise<FormasPagamento[] | null> => {

    let url = `${getUrlAPIv2}/empresas/infoCompanyAndPayment/${empresaID}`;
    try {
        const response = await fetch ( url, {
            headers: {
                "Authorization": `Bearer ${token}`
            },
        } ) ;
        if ( response.status === 200 ) {
            const data = await response.json ( );
            return data.data ;
        }
        return null
    } catch ( error ) {
        console.log ( error ) ;
        return null ;
    }
};

export { getFormaPagamentoEmpresa };